import { useEffect } from 'react';

import cn from 'classnames';
import { Tab, Tabs } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Button, FormMessage, MessageType, ToggleSwitch } from 'components/FormComponents';

import { updateCompany } from 'api/company-slice';

import { ActiveDirectoryConfig } from './tabs/ActiveDirectoryConfig/ActiveDirectoryConfig';
import { SingleSignOnConfig } from './tabs/SingleSignOnConfig/SingleSignOnConfig';

export const AuthenticationSecurity = ({ company, setLoading = () => {} }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { register, reset, handleSubmit } = useForm();

  const ssoEnabled = !!company.sso_enabled;

  const onCompanyUpdate = params => dispatch(updateCompany({ id: company.id, params }));

  useEffect(() => {
    reset({ enforce_two_factor_auth: company.enforce_two_factor_auth && !ssoEnabled });
  }, [company]);

  const onSubmit = async data => {
    setLoading(true);
    await onCompanyUpdate(data);
    setLoading(false);
  };

  return (
    <form className={cn('d-flex', 'justify-content-center')} onSubmit={handleSubmit(onSubmit)}>
      <div className={cn('card', 'card-with-border')}>
        <div className={cn('u-padding--large')}>
          <div className={cn('u-flex-box', 'u-flex-justify-between', 'u-flex-align-center')}>
            <h1 className="title-2">Authentication Security</h1>
          </div>
          <p className="t-small">
            Edit the authentication security settings of your company below.
          </p>
        </div>
        <Tabs defaultActiveKey="mfa" className="tabs no-padding">
          <Tab eventKey="mfa" title="Multiple Factor Authentication">
            <div className={cn('background-secondary', 'u-padding')}>
              <div className={cn('card', 'card-with-border', 'u-padding')}>
                {ssoEnabled && (
                  <FormMessage
                    type={MessageType.Info}
                    message={t('company.tabs.authenticationSecurity.twoFactorManagedBySso')}
                    closeable={false}
                    className="u-margin-top--0"
                  />
                )}
                <ToggleSwitch
                  register={register}
                  className="u-margin-bottom--0"
                  name="enforce_two_factor_auth"
                  disabled={ssoEnabled}
                  tooltip="We recommend notifying the organization members and asking them to enable 2FA for their accounts before enforcing this setting."
                  label="Require Two-factor Authentication for all users"
                />
              </div>
            </div>
            <div className={cn('card_footer', 'u-flex-box', 'u-flex-justify-end')}>
              <Button submit disabled={ssoEnabled}>
                Save
              </Button>
            </div>
          </Tab>
          <Tab eventKey="sso" title="Single Sign-On">
            <SingleSignOnConfig />
          </Tab>
          <Tab eventKey="active_directory" title="Active Directory">
            <ActiveDirectoryConfig setLoading={setLoading} />
          </Tab>
        </Tabs>
      </div>
    </form>
  );
};
